import React from 'react';
import PropTypes from 'prop-types';
import { keyboardCodes } from 'common/util/accessibility-helper';
import { translate } from 'common/localization';
import { isQueryMatch, respondToQueryMatch } from 'common/util/matchmedia-helper';

class SubCategoryMenu extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    isOpen: PropTypes.bool,
    menuItem: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    subcategories: PropTypes.arrayOf(PropTypes.shape({
      alias: PropTypes.string.isRequired,
      seoUrlToken: PropTypes.string.isRequired,
    })),
    onFocusChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    subcategories: [],
    isOpen: false,
    url: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      shouldCollapse: false,
      focusedItem: -1,
    };

    this.focusedMenu = React.createRef();
    this.focusedItem = React.createRef();
    this.amtItems = props.url ? props.subcategories.length : props.subcategories.length - 1;
    this.isMobileMenu = !isQueryMatch('medium');
    this.queryListener;

    this.closeMenu = this.closeMenu.bind(this);
    this.handleKey = this.handleKey.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.resetMenu = this.resetMenu.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.shouldCollapse && props.isOpen !== state.isOpen) {
      return {
        isOpen: props.isOpen,
      };
    }

    return null;
  }

  componentDidMount() {
    this.queryListener = respondToQueryMatch('medium', this.resetMenu);
  }

  componentWillUnmount() {
    this.queryListener.removeListener(this.resetMenu);
  }

  closeMenu() {
    this.setState({
      isOpen: false,
      shouldCollapse: true,
      focusedItem: -1,
    });
  }

  handleKey(event) {
    const { isOpen, focusedItem } = this.state;

    if (isOpen && event.keyCode === keyboardCodes.up) {
      event.preventDefault();
      const prevItem = focusedItem <= 0 ? this.amtItems : focusedItem - 1;

      this.setState({
        focusedItem: prevItem,
      });
    } else if (isOpen && event.keyCode === keyboardCodes.down) {
      event.preventDefault();
      const nextItem = focusedItem >= this.amtItems ? 0 : focusedItem + 1;

      this.setState({
        focusedItem: nextItem,
      });
    } else if (event.keyCode === keyboardCodes.esc) {
      this.closeMenu();
      this.focusedMenu.current.focus();
    } else if (event.keyCode === keyboardCodes.tab) {
      this.closeMenu();
    }
  }

  openMenu() {
    this.setState({
      isOpen: true,
      shouldCollapse: false,
      focusedItem: -1,
    });
    this.props.onFocusChange(this.props.menuItem);
  }

  resetMenu() {
    this.isMobileMenu = !isQueryMatch('medium');
    this.closeMenu();
  }

  setFocus(element) {
    if (element) {
      element.focus();
      this.focusedItem = element;
    }
  }

  toggleMenu() {
    if (this.state.isOpen && this.state.focusedItem < 0) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  render() {
    const {
      subcategories,
      name,
      url,
      menuItem,
    } = this.props;
    const { isOpen, focusedItem } = this.state;

    return (
      <li
        className={`cat-menu__item qa-menu-group cat-menu__toggle-btn${isOpen ? ' cat-menu__toggle-btn--open' : ''}`}
        onMouseEnter={!this.isMobileMenu ? this.openMenu : null}
        onMouseLeave={!this.isMobileMenu ? this.closeMenu : null}
        onKeyDown={this.handleKey}
      >
        <button aria-expanded={isOpen} aria-controls={`cat-submenu-${menuItem}`} ref={this.focusedMenu} className="cat-menu__label" title={name} onClick={this.toggleMenu}>{name}</button>
        <ul className={`subcat-menu${isOpen ? ' subcat-menu--open' : ''}`} id={`cat-submenu-${menuItem}`}>

          {subcategories.map((subcat, idx) => (
            <li className="subcat-menu__item" key={`subcat-${idx}`}>
              <a ref={focusedItem === idx && this.setFocus} className="subcat-menu__label" tabIndex="-1" href={subcat.seoUrlToken}>{subcat.alias}</a>
            </li>
          ))}
          {url &&
            <li className="subcat-menu__item">
              <a ref={focusedItem === this.amtItems && this.setFocus} tabIndex="-1" className="subcat-menu__label" href={url}>{translate('shop.all.title')}</a>
            </li>
          }
        </ul>
      </li>
    );
  }
}

export default SubCategoryMenu;
